import { appMarkerLogger } from '../bootstrap';
import type { FullStoryInstance } from '../types/globals';

const logger = appMarkerLogger.child({ name: 'getCurrentSessionURL' });

export const getCurrentSessionURL = () => {
  if (typeof window !== 'undefined') {
    const fullStoryInstance = window['FS'] as FullStoryInstance;

    if (fullStoryInstance) {
      try {
        return fullStoryInstance.getCurrentSessionURL(true);
      } catch (err) {
        logger.warn("Can't get FullStory session URL");
      }
    }
  }
};
